// Registry of event types. Add a new type = create its file, import it, and add
// it to the array below. Each type owns its own wizardSteps and (optionally)
// planPages, so the system grows by adding files — not by editing shared logic.

// Professional
import conference from "./conference.js";
import medicalCme from "./medicalCme.js";
import workshop from "./workshop.js";
import webinar from "./webinar.js";
import productLaunch from "./productLaunch.js";
import networking from "./networking.js";
// Personal
import wedding from "./wedding.js";
import birthday from "./birthday.js";
import anniversary from "./anniversary.js";
import babyShower from "./babyShower.js";
import housewarming from "./housewarming.js";
// Catch-all stub
import other from "./other.js";

export const EVENT_TYPES = [
  conference, medicalCme, workshop, webinar, productLaunch, networking,
  wedding, birthday, anniversary, babyShower, housewarming,
  other,
];

// Ordered categories for grouping the chooser.
export const CATEGORIES = [
  { id: "personal", label: "Personal", blurb: "Weddings, birthdays & family celebrations." },
  { id: "professional", label: "Professional", blurb: "Conferences, workshops & business events." },
];

const byId = Object.fromEntries(EVENT_TYPES.map((t) => [t.id, t]));

export function getEventType(id) {
  return byId[id] ?? null;
}

// Only types users can actually pick right now.
export const selectableEventTypes = EVENT_TYPES.filter((t) => t.enabled !== false);

// Types grouped by category, in CATEGORIES order. Used by the chooser.
export function eventTypesByCategory() {
  return CATEGORIES.map((category) => ({
    ...category,
    types: EVENT_TYPES.filter((t) => (t.category || "professional") === category.id),
  })).filter((group) => group.types.length);
}
